import React from 'react';
import PropTypes from 'prop-types';
import { FileUpload as UDSFileUpload, Divider } from '@telus-uds/components-web';
import request from '../../../../utils/request';

const FileUpload = ({ addFileToList, orderId }) => {
  const handleUpload = async files => {
    const results = await Promise.all(
      files.map(async file => {
        try {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('typeId', 0);
          const result = await request.post(
            `/orders/${orderId}/upload-file`,
            formData
          );

          if (result && result.data && result.data.orderFiles) {
            addFileToList(result.data.orderFiles);
          }

          return {};
        } catch (error) {
          return { error: error?.message || 'Upload failed' };
        }
      })
    );

    return results;
  };

  const handleDelete = async () => {
    return {};
  };

  // FB2-12: Normalize file-type casing between the hint ("Allowed file types: PDF.")
  // and the validation error. UDS substitutes %{fileTypes} (hint) and %{fileType}
  // (error) differently, so we hardcode the error copy to match the hint's "PDF".
  const dictionary = {
    en: {
      label: 'Upload files',
      buttonLabel: 'Choose files',
      dismissButtonLabel: 'Remove file',
      wrongFileType: 'The selected file must be a PDF',
      // FB2-11b: Rendered in the native hint slot (between the "Upload files"
      // heading and the "Choose files" button) and styled as a note via CSS
      // (see .attachments-file-upload rules in style.css).
      allowedFileTypes: 'Allowed file types: PDF',
      fileTooBig: 'The selected file must be smaller than %{size}MB.',
      fileIsEmpty: 'The selected file is empty.',
      problemUploading: 'The selected file could not be uploaded. Try again.',
      problemDeleting: 'The selected file could not be deleted. Try again.',
      problemUploadingMultipleFiles:
        'The selected files could not be uploaded. Try again.',
      only: 'only',
      and: 'and',
      or: 'or',
      uploadSuccess: 'uploaded successfully.',
      uploadError: 'was not uploaded due to',
      deleteProblem: 'was not deleted due to',
      tooManyFiles:
        'You can only select up to %{maxFilesCount} files at the same time.',
      fileTooSmall: 'The selected file must be at least %{size}MB.',
      fewFiles: 'You must select at least %{minFilesCount} files.'
    }
  };

  return (
    <div className="attachments-file-upload">
      <Divider space={1} variant={{ inverse: true }} />
      <UDSFileUpload
        copy="en"
        dictionary={dictionary}
        fileTypes={['pdf']}
        maxFileSize={5}
        maxFilesCount={1}
        onUpload={handleUpload}
        onDelete={handleDelete}
      />
    </div>
  );
};

FileUpload.propTypes = {
  addFileToList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FileUpload;
